import './App.css';
import Header from './components/Header';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Featutres from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import WhatItSolves from './components/WhatItSolves';
import Clients from './components/Clients';
import ContactUs from './components/ContactUs';

function App() {
  return (
    <div className="App">
      <Header />
      <WhatItSolves />
      <Featutres />
      <HowItWorks />
      <Pricing />
      <Testimonials />
      <Clients/>
      <ContactUs/>
      <Footer />
    </div>
  );
}

export default App;
